<!--
pouziva sa v router upladop nazov url
View pre vlozenie obcianskeho preukazu prostrednictvom OTP(one time password), bude pouzivat UploadArea
-->

<template>
  <div id="loginOTP">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-img
            src="../assets/img/logo-tl.png"
            width="80"
            class="mt-8 tl_logo"
            style="margin: auto"
          ></v-img>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="3" class="login_slim">
          <v-card elevation="10" class="login_card">
            <v-card-text class="login">
              <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="12">
                  <h1 align="center" style="font-size: 22px !important">
                    Vložte prosím
                    {{ zahranicnaOsoba ? 'povolenie na pobyt' : 'občiansky preukaz' }}
                  </h1>
                  <h1 align="center" style="font-size: 22px !important">
                    pre {{ cisloObchPripadu }}
                  </h1>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <upload-area ref="refuploadarea"></upload-area>
                  <v-divider class="my-20px"></v-divider>

                  <v-btn class="btn-primary" @click="dmsSave()" :disabled="uloadujemData">
                    <v-icon left> mdi-upload-outline </v-icon>
                    Nahrať
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="">
        <v-col align="center" class="v-copyright" cols="12" sm="8" md="8">
          V spolupráci s <b>NCC a.s.</b> © 2020
        </v-col>
      </v-row>

      <!-- ##############  -->
      <!-- SNACKBAR -->
      <!-- TODO: ked sa budes nudit, spravit aby generoval dynamicky snackbary -->
      <!-- ##############  -->
      <v-snackbar
        :class="{
          'snack-ok': snackbar.error === 0,
          'snack-error': snackbar.error > 0,
        }"
        v-model="snackbar.show"
        :timeout="snackbar.timeout"
      >
        {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
          <v-btn class="link" elevation="0" v-bind="attrs" @click="snackbar.show = false">
            Zavrieť
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import TextGroup from '../components/basic/TextGroup.vue';
import DynamicCombo from '../components/basic/DynamicCombo.vue';
import TextBox from '../components/basic/TextBox.vue';
import DatePicker from '../components/basic/DatePicker.vue';
import NumericTextBox from '../components/basic/NumericTextBox.vue';
import ButtonGroup from '../components/basic/ButtonGroup.vue';
import Ico from '../components/basic/Ico.vue';
import UploadArea from '../components/basic/UploadArea.vue';
import { mapState } from 'vuex';
import protectedAxios from '../auth/axios.js';
import Axios from 'axios';

export default {
  components: {
    ButtonGroup,
    TextGroup,
    DynamicCombo,
    TextBox,
    DatePicker,
    NumericTextBox,
    Ico,
    UploadArea,
  },
  data() {
    return {
      snackbar: {
        timeout: 5000,
        text: null,
        show: false,
        error: 0,
      },
      uloadujemData: false,
      cisloObchPripadu: '',
      zahranicnaOsoba: false,
    };
  },
  methods: {
    dmsSave() {
      this.uloadujemData = true;
      this.$refs.refuploadarea.filesSaved(() => {
        //this.dialog = false;
        this.snackbar.text = 'Vaše prílohy boli úspešne odoslané.';
        this.snackbar.error = 0;
        this.snackbar.show = true;
        this.uloadujemData = false;
      });
      this.$refs.refuploadarea.filesNotSaved(() => {
        this.uloadujemData = false;
      });

      this.$refs.refuploadarea.saveotp(this.otp);
    },
    loadData() {
      this.sendingRequest = true;

      protectedAxios
        .get('/otp/info', {
          params: {
            guidOtp: this.otp.guid,
            pinOtp: this.otp.pin,
          },
        })
        .then(res => {
          this.cisloObchPripadu = res.data.cisloObchPripadu;
          this.zahranicnaOsoba = res.data.zahranicnaOsoba;
        })
        .catch(e => {
          console.log('Pri volani /otp/info   nastala chyba.');
        });
    },
    validate() {
      //this.$refs.form.validate();
      //console.log(this.$refs.form.inputs[0].cisloObchPripadu);
    },
  },
  computed: {
    ...mapState(['otp']),
  },
  mounted() {
    this.loadData();
    //console.log(this.otp);
  },
};
</script>
